var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrofeu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 85,
    viewBox: "0 0 90 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9893 6.76332H70.286C70.286 6.76332 66.0949 69.8593 45.1378 69.8593C34.9001 69.8593 28.6634 54.8024 24.9617 39.3991C21.0858 23.271 19.9893 6.76332 19.9893 6.76332Z",
    stroke: "url(#paint0_linear_176_389)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2871 6.76335C70.2871 6.76335 74.6715 2.08642 78.3153 2.0039C85.4544 1.84227 86.7742 6.76335 86.7742 6.76335C88.1715 9.66435 89.289 17.2069 82.583 24.1692C75.8765 31.1315 68.3695 37.2236 65.3145 39.3991",
    stroke: "url(#paint1_linear_176_389)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9905 6.76337C19.9905 6.76337 15.4225 2.03313 11.6838 2.00396C4.54474 1.94823 3.22491 6.76337 3.22491 6.76337C1.82773 9.66432 0.710035 17.2068 7.41633 24.1692C14.1226 31.1315 21.9084 37.2235 24.963 39.3995",
    stroke: "url(#paint2_linear_176_389)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.374 82.9139C28.374 74.2109 45.1394 69.8593 45.1394 69.8593C45.1394 69.8593 61.9054 74.2109 61.9054 82.9139H28.374Z",
    stroke: "url(#paint3_linear_176_389)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_176_389",
    x1: 45.1376,
    y1: 6.76332,
    x2: 45.1376,
    y2: 69.8593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.189143,
    stopColor: "#AC8D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967928,
    stopColor: "#AC8D4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_176_389",
    x1: 76.5743,
    y1: 2,
    x2: 76.5743,
    y2: 39.3991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC8D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC8D4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_176_389",
    x1: 13.564,
    y1: 2.00348,
    x2: 13.564,
    y2: 39.3995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC8D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC8D4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_176_389",
    x1: 45.1397,
    y1: 99.3223,
    x2: 45.1397,
    y2: 61.7928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.275424,
    stopColor: "#AC8D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983051,
    stopColor: "#AC8D4C",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrofeu);
export default __webpack_public_path__ + "static/media/Trofeu.341b0b5ff82f33ff8751e59f6f576f03.svg";
export { ForwardRef as ReactComponent };